<template>
  <div>
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege <= 2"
        >
          <label class="text-sm opacity-75">Branch</label>
          <v-select
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.branch"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full" v-else>
          <vs-input
            disabled
            label="Branch"
            class="w-full"
            :value="actor.ref_branch ? actor.ref_branch.name : '-'"
          />
        </div>
        <div v-if="actor.privilege < 6" class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Owner (Username)</label>
          <v-select
            @search="searchOwner"
            :options="ownerFilterList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.owner"
          />
        </div>
        <div v-else class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input
            disabled
            label="Owner"
            class="w-full"
            :value="actor.username"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-2">
          <label class="text-sm opacity-75">Dealer Status</label>
          <v-select
            :options="list_dealer_search"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="selected_dealer"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="mt-5">
        <div class="flex flex-wrap items-center">
          <div class="flex-grow"></div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{ page * per_page - (per_page - 1) }} -
                {{
                  row_total - page * per_page > 0 ? page * per_page : row_total
                }}
                of {{ row_total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="updatePerPage(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="keyword"
            @keyup="search"
            placeholder="Search..."
          />
        </div>

        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Imei</th>
                <th>Device Name</th>
                <th>Plate No</th>
                <th>Owner</th>
                <th>Dealer Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="99" class="text-center">Loading....</td>
              </tr>
            </tbody>

            <tbody v-else-if="data.length > 0">
              <tr v-for="(item, index) in data" :key="index">
                <td>{{ (page - 1) * per_page + (index + 1) }}</td>
                <td>{{ item.imei }}</td>
                <td>{{ item.device_name }}</td>
                <td>{{ item.plate }}</td>
                <td>{{ item._owner ? item._owner.username : '-' }}</td>
                <td>{{ item.dealer_status }}</td>
                <td style="width: 90px">
                  <div class="flex">
                    <vx-tooltip text="Assigned to dealer status" position="top">
                      <vs-button
                        :id="`editBtn${item.imei}`"
                        type="border"
                        size="small"
                        icon-pack="feather"
                        icon="icon-link-2"
                        color="success"
                        class="mr-2 vs-con-loading__container"
                        @click="edit(item.imei, item.plate, item.dealer_status)"
                      ></vs-button>
                    </vx-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="99" class="text-center">No Data Available</td>
              </tr>
            </tbody>
          </table>

          <vs-pagination :total="n_page" v-model="page"></vs-pagination>
        </div>
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/2 w-full mb-5">
            <vs-input
              disabled
              label="Imei"
              class="w-full"
              v-model="input.name"
            />
          </div>
          <div class="vx-col sm:w-2/2 w-full">
            <label class="text-sm opacity-75">Dealer Status</label>
            <v-select
              :options="list_dealer"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="input.dealer"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button
              id="submitBtn"
              class="mr-3 mb-2 vs-con-loading__container"
              @click="submit"
              >Submit</vs-button
            >
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      data: [],
      // dataCommandOnOff: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      actor: {},

      loading: true,
      tempId: 0,

      ownerList: [],
      branchList: [],
      ownerFilterList: [],

      input: {
        id: '',
        name: '',
        dealer: []
      },

      filter: {
        branch: '',
        owner: ''
      },

      list_dealer: [
        {
          value: '1S',
          label: '1S'
        },
        {
          value: '3S',
          label: '3S'
        }
      ],

      list_dealer_search: [
        {
          value: '',
          label: 'All'
        },
        {
          value: '1S',
          label: '1S'
        },
        {
          value: '3S',
          label: '3S'
        }
      ],

      selected_dealer: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dealer() {
      return this.selected_dealer ? this.selected_dealer.value : ''
    },

    filterBranch() {
      return this.filter.branch ? this.filter.branch.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    input: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    },

    dealer() {
      this.page = 1
      this.initTable()
      // console.log(this.selected_dealer.value)
    },

    filter: {
      handler(val) {
        this.page = 1
        this.initTable()
      },
      deep: true
    },

    filterBranch() {
      this.filter.owner = ''
      this.selected_dealer = ''
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        // if(this.actor.privilege >= 4) {
        //   this.ownerFilterList.push({ value: this.actor.id, label: this.actor.username })
        //   this.exportData.username = { value: this.actor.id, label: this.actor.username }
        // }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.getBranchList()
    this.initTable()
  },

  mounted() {},

  methods: {
    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data
          if (this.actor.privilege >= 3)
            this.input.branch = this.branchList.find((item) => {
              return item.value === this.actor.branch
            })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchOwner(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch: this.filter.branch ? this.filter.branch.value : '',
              search: search
            }
          })
          .then((res) => {
            this.ownerFilterList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.ownerFilterList = []
      }
    },

    getOwnerList() {
      this.$http
        .get(`${this.$api.endpoint}/user/owner`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            branch: this.branch
          }
        })
        .then((res) => {
          this.ownerList = res.data.message.data
          if (this.tempOwner) {
            this.input.owner = this.ownerList.find((item) => {
              return item.value === this.tempOwner
            })
          }

          // if(this.actor.privilege > 3) this.input.owner = this.ownerList.find(item => {
          //   return item.value === this.actor.id
          // })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = ''
      })
    },

    initTable() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/gps/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },

          params: {
            page: this.page,
            per_page: this.per_page,
            search: this.keyword,
            dealer_status: this.selected_dealer
              ? this.selected_dealer.value
              : '',
            branch_id: this.filter.branch ? this.filter.branch.value : '',
            owner: this.filter.owner ? this.filter.owner.value : ''
          }
        })
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    edit(id, plate, dealer_status) {
      this.tempId = id
      this.input.name = plate
      this.action = 'edit'
      this.popupTitle = 'Assigned to dealer status'
      this.showPopup = true

      this.input.dealer = this.list_dealer.filter((i) => {
        return i.value == dealer_status
      })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/gps/dealer_status`

      this.$http
        .post(
          url,
          {
            imei: this.tempId,
            dealer_status: this.input.dealer ? this.input.dealer.value : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()
          this.reset()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
